import axios from "axios";

export const payManually = async (action, id, type) => {
  try {
    const token = localStorage.getItem("token");
    const data = {
      action: action,
      id: id,
      type: type,
    };
    const config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: process.env.VUE_APP_BANK_BATCHS,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    };
    const response = await axios.request(config);
    console.log(response);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
